// ControlledRichTextEditor.tsx
import {
  Controller,
  type Control,
  type FieldValues,
  type Path
} from 'react-hook-form';
import RichTextEditor from './RichTextEditor';
import { FormHelperText } from '@mui/material';

type Props<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  textLimit?: number;
  onSave?: { label?: string; action: () => void; isLoading?: boolean };
  rules?: Parameters<typeof Controller<T>>[0]['rules'];
};

export function ControlledRichTextEditor<T extends FieldValues>({
  control,
  name,
  textLimit,
  onSave,
  rules
}: Props<T>) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <>
          <RichTextEditor
            value={(field.value as string) ?? ''}
            onChange={field.onChange}
            onBlur={field.onBlur}
            textLimit={textLimit}
            onSave={onSave}
          />
          {fieldState.error && (
            <FormHelperText error>{fieldState.error.message}</FormHelperText>
          )}
        </>
      )}
    />
  );
}
